export class ClipboardFailed extends Error {
  public constructor() {
    super()

    this.message = 'errors.clipboardFailed'
  }
}
